<script setup>
import { useDialogPluginComponent } from 'quasar'
import { reactive, ref, toRefs } from 'vue'
import { useQuasar } from 'quasar'
import { useI18n } from 'vue-i18n'
import apiDevice from '../../../api/device.api'
import useDevice from '../../../store/device.store'

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const { getDeviceList } = useDevice()
const $q = useQuasar()
const { t } = useI18n()

const props = defineProps({
  id: String
})

const { id } = toRefs(props)
const loading = ref(false)
const confirmDialog = ref(false)
const data = reactive({
  deviceId: '',
  deviceNumber: '',
  price: '',
})

function showSubmit () {
  confirmDialog.value = true
}

async function deleteDevice() {
  try {
    loading.value = true
    await apiDevice.remove(id.value)
    getDeviceList()
    onDialogOK()
  } catch (error) {
    $q.notify({ message: error?.data?.error, type: 'negative' })
  } finally {
    loading.value = false
  }
}


async function submit () {
  try {
    loading.value = true

    await apiDevice.update()

    getDeviceList()
    onDialogOK()
  } catch (error) {
    $q.notify({ message: error?.data?.error, type: 'negative' })
  } finally {
    loading.value = false
  }
}

function init (params) {
  data.deviceId = String(params.deviceId)
  data.deviceNumber = params.deviceNumber
  data.price = String(params.price)
}

async function fetch () {
  loading.value = true

  const { data } = await apiDevice.getOne(id.value)
  init(data)

  loading.value = false
}

fetch()

</script>

<template lang='pug'>
.role-update
  q-dialog(ref='dialogRef' persistent)
    q-card.overflow-hidden(style='width: 400px; max-width: 80vw;')
      q-form(@submit='showSubmit')
        q-card-section
          .text-h6 {{ t('roles.update_title') }}
        q-separator
        q-card-section.scroll(style='max-height: 70vh; min-height: 40vh;')
          q-input.q-ma-xs.q-mt-sm(
            stack-label
            outlined
            v-model='data.deviceId'
            :label="t('roles.code')"
            no-error-icon
            hide-bottom-space
            hide-hint
          )
          q-input.q-ma-xs.q-mt-sm(
            stack-label
            outlined
            v-model='data.deviceNumber'
            :label="t('roles.name')"
            no-error-icon
            hide-bottom-space
            hide-hint
          )
          q-input.q-ma-xs.q-mt-sm(
            stack-label
            outlined
            v-model='data.price'
            :label="t('roles.price')"
            no-error-icon
            hide-bottom-space
            hide-hint
          )

        q-separator
        q-card-actions(align='right')
          q-btn(
            flat
            unelevated
            color='red'
            @click='deleteDevice'
            :label="t('roles.delete')")
          q-space
          q-btn(
            flat
            unelevated
            color='grey'
            @click='onDialogCancel'
            :label="t('actions.cancel')")
          q-btn(
            flat
            type='submit'
            unelevated
            color='primary'
            :label="t('actions.save')")
            q-separator
          
      q-inner-loading(:showing='loading')

  q-dialog(v-model='confirmDialog' persistent)
    q-card
      q-card-section
        q-icon(size='lg' name='priority_high' color="yellow")
        span {{ t('roles.confirm_update_text') }}
      q-card-actions(align='right')
        q-btn(flat unelevated color='grey' :label="t('actions.no')" v-close-popup)
        q-btn(flat unelevated color='primary' :label="t('actions.yes')" v-close-popup @click='submit')
  </template>